/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var MessageType;

(function (MessageType) {
  MessageType["INTERNAL"] = "internal";
  MessageType["TO_BROKER"] = "to_broker";
  MessageType["FROM_BROKER"] = "from_broker";
  MessageType["FROM_ORG"] = "from_org";
})(MessageType || (MessageType = {}));